import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { store, StoreContext } from './stores/Store';
import { Router } from 'react-router-dom';
import ScrollToTop from './layout/ScrollToTop';
import App from './layout/App';

import 'semantic-ui-css/semantic.min.css';
// import 'semantic-ui-forest-themes/semantic.yeti.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

export const history = createBrowserHistory();

ReactDOM.render(
  <StoreContext.Provider value={store}>
    <Router history={history}>
      <ScrollToTop />
      <App />
    </Router>
  </StoreContext.Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
